module.exports = __webpack_public_path__ + "img/icon-tipo-veto2.58e14734.png";